"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _bbcode = require("./bbcode.0.4.0-bobtv");
var _app = _interopRequireDefault(require("../../app.config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var options = {};
var fontNames = _app["default"].font_names;
var fontFamilies = [];
if (fontNames) {
  var fontEntries = fontNames.split(";");
  for (var i = 0; i < fontEntries.length; i++) {
    var parts = fontEntries[i].split("/");
    var compressedFontFamily = parts[0].replace(/\s+/g, '');
    fontFamilies[compressedFontFamily] = parts[1];
  }
}
options.defaultFontFamily = _app["default"].default_font_family;
options.fontFamilies = fontFamilies;
options.currentNick = "";
function bbcodeRender(content, opts) {
  var real_options = _typeof(opts) == 'object' ? _objectSpread(_objectSpread({}, options), opts) : options;
  if (_typeof(opts) == 'object' && opts.extractAttachments) {
    return (0, _bbcode.render_and_extract_attachments)(content, real_options);
  } else {
    return (0, _bbcode.render)(content, real_options);
  }
}
var _default = exports["default"] = bbcodeRender;